import styled, { css } from 'styled-components';
import { PalletteProps, pallette } from '../../types/theme/pallette';

type sizes = 'small' | 'medium' | 'big';
type variations = 'primary' | 'secondary' | 'alternative';
interface props extends PalletteProps {
  variation: variations;
  size: sizes;
  disabled?: boolean;
}

const getPadding = (size: sizes) => {
  switch (size) {
    case 'small':
      return '8px 30px';
    case 'medium':
      return '10px 30px';
    case 'big':
      return '16px 30px';
    default:
      return 'unset';
  }
};

const getBackground = (variation: variations, theme: pallette) => {
  switch (variation) {
    case 'primary':
      return theme.primaryColor;
    case 'secondary':
      return theme.lightGray;
    case 'alternative':
      return 'white';
    default:
      return 'unset';
  }
};

const getColor = (variation: variations, theme: pallette) => {
  switch (variation) {
    case 'primary':
      return 'transparent';
    case 'secondary':
      return theme.primaryColor;
    case 'alternative':
      return 'transparent';
    default:
      return 'unset';
  }
};

const getFontColor = (variation: variations, theme: pallette) => {
  switch (variation) {
    case 'primary':
      return 'white';
    case 'secondary':
      return theme.primaryColor;
    case 'alternative':
      return theme.darkGray;
    default:
      return 'unset';
  }
};

const sharedStyles = css<props>`
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  padding: ${({ size }) => getPadding(size)};
  background-color: ${({ theme, variation, disabled }) =>
    disabled ? theme.gray4 : getBackground(variation, theme)};
  border: solid 1px ${({ theme, variation }) => getColor(variation, theme)};
  color: ${({ theme, variation }) => getFontColor(variation, theme)};
  border-radius: 10px;
  font-weight: 700;
  transition: ease all 200ms;
  box-shadow: 0px 0px 50px rgba(200, 200, 200, 0.2);
  text-transform: uppercase;

  .faIcon {
    margin-right: 8px;
  }

  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background-color: ${({ theme, disabled }) =>
      disabled ? theme.gray6 : theme.primaryColor};
    opacity: ${({ disabled }) => (disabled ? 0.9 : null)};
    color: ${({ theme }) => theme.white};
  }

  @media ${({ theme }) => theme.breakpoints.mobileL} {
    font-weight: 900;
  }
`;

export const AnchorButton = styled.a`
  ${sharedStyles}
`;

export const ClickButton = styled.button`
  ${sharedStyles}
`;
